import script from "./StudentProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentProfile.vue?vue&type=script&setup=true&lang=js"

import "./StudentProfile.vue?vue&type=style&index=0&id=2e27fcd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e27fcd4"]])

export default __exports__